module.exports = __webpack_public_path__ + "img/Akute_Gefahr.6bf7c083.svg";